module.exports = __webpack_public_path__ + "static/media/OBGYN-Menstrual, Sexual, and Gynecological History-1@3x.351c6f51.png";